export default __webpack_public_path__ + "static/media/creditsteaser.da5ebc8f.jpg";